var React = require('react');

function AddIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.8332 5.83333H9.16651V9.16667H5.83317V10.8333H9.16651V14.1667H10.8332V10.8333H14.1665V9.16667H10.8332V5.83333ZM9.99984 1.66666C5.39984 1.66666 1.6665 5.4 1.6665 10C1.6665 14.6 5.39984 18.3333 9.99984 18.3333C14.5998 18.3333 18.3332 14.6 18.3332 10C18.3332 5.4 14.5998 1.66666 9.99984 1.66666ZM9.99984 16.6667C6.32484 16.6667 3.33317 13.675 3.33317 10C3.33317 6.325 6.32484 3.33333 9.99984 3.33333C13.6748 3.33333 16.6665 6.325 16.6665 10C16.6665 13.675 13.6748 16.6667 9.99984 16.6667Z","fill":"#0067DD"}));
}

AddIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = AddIcon;

AddIcon.default = AddIcon;
